<template>
	<div>
		<v-divider class="my-5" />

		<v-layout wrap class="mb-4">
			<div class="verCenteredChild mb-1">
				<h5 class="subheader ma-0">Money Earned</h5>
				<div class="text-xs-center">
					<payment-policy :themeInputColor="themeInputColor" />
				</div>
			</div>
		</v-layout>

		<h5 class="title sub--text">Total Amount Earned (till now)</h5>
		<v-layout class="mb-4">
			<div
				class="wallet-info--wrapper d-flex"
				v-for="(item,index) in walletDetailsSkelton"
				:key="index"
			>
				<div
					class="wallet-info d-flex pa-2"
					:class="`${index < 2 ? `blue lighten-${1 - index}` : `blue darken-${index - 3}`}`"
				>
					<v-icon size="50" class="px-2" color="white">{{item.icon}}</v-icon>
					<div class="py-1 px-2 margin--auto">
						<div class="headline">
							<span>&#8377;</span>
							{{walletDetails.total[item.earned] || 0}}
						</div>
						<div class="caption">{{item.title}}</div>
					</div>
				</div>
				<v-icon v-if="index<4" class="px-2" :color="themeInputColor">{{ index &lt; 3 ? "add" : "=" }}</v-icon>
			</div>
		</v-layout>

		<h5 class="title sub--text">Amount Earned (this month)</h5>
		<v-layout>
			<div
				class="wallet-info--wrapper d-flex"
				v-for="(item,index) in walletDetailsSkelton"
				:key="index"
			>
				<div
					class="wallet-info d-flex pa-2"
					:class="`${index < 2 ? `light-blue lighten-${1 - index}` : `light-blue darken-${index - 3}`}`"
				>
					<v-icon size="50" class="px-2" color="white">{{item.icon}}</v-icon>
					<div class="py-1 px-2 margin--auto">
						<div class="headline">
							<span>&#8377;</span>
							<span>{{walletDetails.currentMonth[item.earned]}}</span>
						</div>
						<div class="caption">{{item.title}}</div>
					</div>
				</div>
				<v-icon v-if="index<4" class="px-2" :color="themeInputColor">{{ index &lt; 3 ? "add" : "=" }}</v-icon>
			</div>
		</v-layout>

		<v-divider class="my-5" />

		<h5 class="subheader ma-0">Withdraw Money</h5>
		<v-layout class="verCenteredChild pt-3">
			<v-flex xs6>
				<div class="title blue--text">
					Current Available Balance:
					<span class="headline">&#8377;</span>
					<span class="headline">{{walletDetails.walletBalance}}</span>
				</div>
			</v-flex>
			<v-flex xs2 class="mx-4">
				<v-text-field label="Enter Amount to withdraw" v-model="amountToSend" placeholder="100"></v-text-field>
			</v-flex>
			<v-flex xs3 class="px-2 mx-3">
				<v-btn :color="themeInputColor" class="white--text" @click="withdrawMoney">Withdraw</v-btn>
			</v-flex>
		</v-layout>

		<v-divider class="my-5" />

		<otp-modal
			:otpModal="otpModal"
			:amount="amountToSend"
			heading="Verify OTP to complete transaction"
			:isLoading="makeTransactionLoading"
			:themeInputColor="themeInputColor"
			@ACTION_BUTTON_CLICKED="makeTransaction"
			@CLOSE_OTP_MODAL="otpModal = false"
		/>
	</div>
</template>

<script>
import PaymentPolicy from "./payment-policy";
import OTPModal from "@/components/otp-modal";

import { MAKE_TRANSACTION, SEND_SMS, SHOW_ALERT } from "@/store/action-types";

export default {
	name: "WithdrawMoney",
	props: [
		"themeInputColor",
		"username",
		"userId",
		"walletDetails",
		"paymentDetails",
		"isPaymentDetailsPresent"
	],
	data() {
		return {
			amountToSend: null,
			otpModal: false,
			walletDetailsSkelton: [
				{
					icon: "person",
					title: "Sign Up",
					earned: "signUp"
				},
				{
					icon: "person_add",
					title: "Sign Up Bonus",
					earned: "signUpBonus"
				},
				{
					icon: "image",
					title: "Content Creation",
					earned: "contentEarned"
				},
				{
					icon: "add_photo_alternate",
					title: "Content Bonus",
					earned: "contentBonus"
				},
				{
					icon: "account_balance_wallet",
					title: "Amount Earned",
					earned: "amountEarned"
				}
			],
			makeTransactionLoading: false
		};
	},
	components: {
		"payment-policy": PaymentPolicy,
		"otp-modal": OTPModal
	},
	methods: {
		makeTransaction({ otp }) {
			if (!this.makeTransactionLoading) {
				this.makeTransactionLoading = true;
				const to_send = {
					userId: this.userId,
					mode: "bank",
					otp,
					username: this.username,
					amount: this.amountToSend
				};
				this.$store
					.dispatch(MAKE_TRANSACTION.dispatch, to_send)
					.catch(() => {})
					.then(() => {
						this.makeTransactionLoading = false;
						this.otpModal = false;
						this.amountToSend = null;
					});
			}
		},
		withdrawMoney() {
			if (this.isPaymentDetailsPresent) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {});
			} else if (
				!this.paymentDetails.status ||
				this.paymentDetails.status !== "success"
			) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Please verify your payment details first!!"
				});
				return;
			}
			this.otpModal = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.wallet-info--wrapper {
	max-width: 18%;
	width: 18%;
	/* background: linear-gradient(180deg, #2089e6, #41a4f4); */
}
.wallet-info {
	border-radius: 8px;
	text-align: center;
	color: white;
	overflow: hidden;
}
.sub--text {
	color: #9a9a9a;
	font-weight: 400;
}
</style>
